// ✅ Import core React libraries
import React from 'react';
import ReactDOM from 'react-dom/client';

// ✅ Import routing support
import { BrowserRouter } from 'react-router-dom';

// ✅ Import global CSS and the main App component
import './index.css';
import App from './App';

// ✅ Import global state providers (Context API)
import { ClientProvider } from './contexts/ClientContext';
import { QuestionsProvider } from './contexts/QuestionContext';

// ✅ Create a root React DOM tree and render the application
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // 🔁 Enables client-side routing (e.g., navigation between pages)
  <BrowserRouter>
    {/* 🌐 Provides client-level shared data to the whole app */}
    <ClientProvider>
      {/* 📚 Provides question-related shared data across components */}
      <QuestionsProvider>
        {/* 🚀 Main application component */}
        <App />
      </QuestionsProvider>
    </ClientProvider>
  </BrowserRouter>
);
